import { NavigateFunction } from "react-router";
import { billtrustBaseURL, salesforceBaseURL } from "constants/endpoints.ts";
import { models } from "types/api/viewModels.ts";
import { CabinetworksGroupApplication, CabinetworksGroupApplicationType } from "types/declarations/enums.ts";

export interface NavigationDestination {
	application?: CabinetworksGroupApplicationType;
	path: string;
}

export const getHomeNavigationDestination = (
	navigation?: models["NavigationViewModel"]
): NavigationDestination | undefined => {
	if (navigation?.home?.path) {
		return {
			application: navigation.home.application,
			path: navigation.home.path
		};
	}

	const dashboardMenu = navigation?.menus?.find(
		(menu) => menu.id === "nav-dashboard" || menu.title?.trim().toLowerCase() === "dashboard"
	);
	const dashboardItem = dashboardMenu?.items?.find((item) => Boolean(item.path));
	if (!dashboardItem?.path) return undefined;

	return {
		application: dashboardItem.application,
		path: dashboardItem.path
	};
};

export const getNavigationDestinationHref = ({ application, path }: NavigationDestination) => {
	if (/^https?:\/\//i.test(path)) return path;

	const normalizedPath = path.startsWith("/") ? path : `/${path}`;
	if (application === CabinetworksGroupApplication.Salesforce) {
		return `${salesforceBaseURL.replace(/\/$/, "")}${normalizedPath}`;
	}
	if (application === CabinetworksGroupApplication.BillTrust) {
		return `${billtrustBaseURL.replace(/\/$/, "")}${normalizedPath}`;
	}

	return path;
};

export const navigateToNavigationDestination = (destination: NavigationDestination, navigate: NavigateFunction) => {
	if (destination.application === CabinetworksGroupApplication.Tandem) {
		navigate(destination.path);
		return;
	}

	globalThis.location.href = getNavigationDestinationHref(destination);
};
